import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import SelectDropDown from '../component/SelectDropDown'
import RegistrationService from '../services/registration'
import InputField from '../component/InputField'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import DatePicker from '../component/DatePicker'
import OtherService from '../services/Other'
import AlertMsg from '../component/AlertMsg'
import { useNavigate } from 'react-router-dom'
import Loader from "../component/Loader";
import Button from 'react-bootstrap/Button';
import ColoredButton from '../component/ColoredButton'
import toast from 'react-hot-toast'
import GridModal from '../component/Modals/GridModal'
import DocumentImage from '../component/DocumentImage'
import { jwtDecode } from "jwt-decode";

const InfluencerApproval = () => {
  const [persona, setPersona] = useState([]);
  const [isTseModalVisible, setIsTseModalVisible] = useState(false);
  const [dealerSelected, setDealerSelected] = useState({
    id: '',
    title: ''
  })
  const [loadingReassignBtn, setLoadingReassignBtn] = useState(false);
  const [dealerOption, setDealerOption] = useState([]);
  const [selectedUserDetails, setSelectedUserDetails] = useState();
  const [selectTSEOption, setSelectTSEOption] = useState(false);
  const [findUserBlock, setFindUserBlock] = useState(false);
  const [allTsos, setAllTsos] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState({
    id: '',
    title: ''
  });
  const [selectedTSEList, setSelectedTSEList] = useState([])
  const [selectedTSE, setSelectedTSE] = useState({
    id: '',
    title: ''
  });
  const [findUserOption, setFindUserOption] = useState([])
  const [findUser, setFindUser] = useState({
            id: '',
            title: '',
            phoneNo: '',
            country: '',
            state: '',
            district: '',
            taluka: '',
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            postCode: '',
            districtId: '',
            talukId: '',
            brandId: '',
            contactId:'',
            panNo:'',
            panImage: '',
            aadharNo: '',
            aadharImageFront: '',
            aadharImageBack: '',
            voterId: '',
            voterImageFront: '',
            voterImageBack: '',
            dlNo: '',
            dlImageFront: '',
            dlImageBack: '',
            profilePic: ''
  });
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isButtonLoadingReassign, setIsButtonLoadingReassign] = useState(false);
  const [isSuccessBtnLoading, setIsSuccessBtnLoading] = useState(false);
  const [isRejectBtnLoading, setIsRejectBtnLoading] = useState(false);
  const [reassignBTN, setreassignBTN] = useState(false);
  const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
  const [showAlert, setShowAlert] = useState(false);
  const [isApproveSuccess, setIsApproveSuccess] = useState({ isLogin: true, heading: '', text: '' })
  const [showAlertApprove, setShowAlertApprove] = useState(false);
  const [addressLine1ValidationError, setAddressLine1ValidationError] = useState('');
  const [addressLine2ValidationError, setAddressLine2ValidationError] = useState('');
  const [addressLine3ValidationError, setAddressLine3ValidationError] = useState('');
  const [pinCodeValidationError, setPinCodeValidationError] = useState('');
  const [dealerValidationError, setDealerCodeValidationError] = useState('');
  const [loading, setLoading] = useState(true);
  const [heirCode, setHierCode] = useState();

  const tseBrand = JSON.parse(localStorage.getItem('currentBrand')).id;
  
  //Select Member
  const accessToken = localStorage.getItem('access_token');
  useEffect(() => {
    if (accessToken) {
      const decoded = jwtDecode(accessToken);
      setHierCode(decoded?.dcm_hierarchies_id);
    }
  }, [accessToken]);

  useEffect(() => {
    if (!heirCode) return;

    const payload = {
      loginUserHirarchy: heirCode,
    };
    RegistrationService.listOfTSOs(payload)
      .then(res => {
        const tsos = res.response.Data[0].map(tso => {
          return ({
            id: tso.id,
            title: `${tso.first_name} ${tso.last_name}`,
          });
        });
        setAllTsos(tsos);
      })
      .catch(err => {
      });
  }, [heirCode]);

  useEffect(() => {
    const memberTypeResponse = async () => {
      try {
        const selectedOrg = 2;
        const MemberTypeFetch = await RegistrationService.getHierarchies(selectedOrg);
        if (MemberTypeFetch.success === true && MemberTypeFetch.response.hierarchiesDetails.length > 0) {
          const allHierarchies = MemberTypeFetch.response.hierarchiesDetails;
          // const personaDetails = MemberTypeFetch.response.hierarchiesDetails.map((item, index) => ({
          //   id: item.id,
          //   title: item.name
          // }));
          const contractorOnly = allHierarchies
            .filter(item => item.name === "CONTRACTOR")
            .map(item => ({
              id: item.id,
              title: item.name
            }));
          // setPersona(personaDetails);
          setPersona(contractorOnly);
          setLoading(false)
        }
      } catch (e) {
      }
    };
    memberTypeResponse();
  }, []);

  //UnApproved User
  useEffect(() => {
    const unApprovedUser = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const payload = {
          hierarchy_Id: selectedPersona.id
        };
        const unApprovedUserList = await RegistrationService.getUnApprovedUsers(payload);

        if (unApprovedUserList.success === true && unApprovedUserList.response.data.length > 0) {

          setFindUserOption(unApprovedUserList?.response?.data?.map((item, index) => ({
            id: item?.id,
            title: item?.full_name,
            phoneNo: item?.phone,
            country: item?.dcm_countries_name,
            state: item?.dcm_states_name,
            district: item?.dcm_district_name,
            taluka: item?.dcm_taluka_name,
            addressLine1: item?.line1,
            addressLine2: item?.line2,
            addressLine3: item?.line3,
            postCode: item?.post_code,
            districtId: item?.dcm_district_id,
            talukId: item?.dcm_taluka_id,
            brandId: item?.dcm_brandId,
            contactId: item?.dcm_contacts_id,
            panNo: item.panNo,
            panImage: item.panImage,
            aadharNo: item.aadharNo,
            aadharImageFront: item.aadharImageFront,
            aadharImageBack: item.aadharImageBack,
            voterId: item.voterId,
            voterImageFront: item.voterImageFront,
            voterImageBack: item.voterImageBack,
            dlNo: item.DLNo,
            dlImageFront: item.DLImageFront,
            dlImageBack: item.DLImageBack,
            profilePic: item.profilePic
          })));
          // setLoading(false)

        }
      } catch (e) {
      }
    };
    if (selectedPersona.id) {
      unApprovedUser();
    }

  }, [selectedPersona]);
  // Select TSE
  // useEffect(() => {
  //   const TSEDataFetch = async () => {
  //     try {
      
  //       const token = localStorage.getItem('access_token');
  //       const userInfo = JSON.parse(localStorage.getItem("userData"));
  //       // );
  //       const hierId = userInfo.dcm_hierarchies_id;
  //       const officerId = 'TSE';
  //       const districtId = findUser.districtId;
  //       const talukId = findUser.talukId;
  //       const brandId = findUser.brandId;
  //       const payload = {
  //         userContactId: findUser.id,
          
  //       };
  //       //  
  //       //  );
        
  //       const TSEDataResponse = await RegistrationService.getDealersOrTse(officerId, districtId,talukId,brandId,payload,token);

  //       if (TSEDataResponse.success === true && TSEDataResponse.response.adminDetails.length > 0) {
  //        const mappedTSEList = TSEDataResponse?.response?.adminDetails?.map((item, index) => {
  //           return {
  //             id: item.id,
  //             title: item.full_name
  //           };
  //         });

  //         setSelectedTSEList(mappedTSEList);
  //         // setLoading(false)
  //        }
        
  //     } catch (e) {

  //     }
  //   }
  //   TSEDataFetch();
  // }, [findUser]);

  //Select Dealer
  useEffect(() => {
    const DealerDataFetch = async () => {
      try {
        const token = localStorage.getItem('access_token')
        const payload = {
          userContactId: findUser.id,
        };
        const officerId = 'Dealer';
        const districtId = findUser.districtId;
        const talukId = findUser.talukId;
        // const brandId = findUser.brandId;
        const brandId = tseBrand;
        
        const DealerDataFetchResponse = await RegistrationService.getDealersOrTse(officerId, districtId,'',brandId,payload,token)
        
        if (DealerDataFetchResponse.success == true && DealerDataFetchResponse.response.adminDetails.length > 0) {
          setDealerOption(DealerDataFetchResponse.response.adminDetails.map((item, index) => {
            
            return {
              id: item?.id,
              title: item?.full_name +  ' (' +
              item.id_extern01 +
              ')',
            }
          }))
        }
        // setLoading(false)
      }
      catch (e) {
      }
    }
    DealerDataFetch()
  }, [findUser.id, findUser.districtId])

  const handlePersonaChange = (selectedValue) => {
    setSelectedPersona(selectedValue);
  };
  const handleFindUserChange = (selectedValue) => {
    setFindUser(selectedValue);
    setFindUserBlock(true)
  };
  const handleSelectTSEOption = () => {
    setSelectTSEOption(true)
    

  }
  const handleTSEChoose = (selected) => {
    setSelectedTSE(selected)
    setreassignBTN(true)
  }
  const handleDealerChange = (selected) => {
    setDealerSelected(selected)
    setDealerCodeValidationError('')
  }
  const handleInfluAddressChange = (e) => {
    let value = e.target.value;
        if (e.target.name == 'postCode')  {
            // Remove non-numeric characters
            value = value.replace(/\D/g, '');
        }
    setFindUser({ ...findUser, [e.target.name]: value })
    switch(e.target.name)
    {
      case 'addressLine1':
      setAddressLine1ValidationError('');
      break;
      case 'addressLine2':
      setAddressLine2ValidationError('');
      break;
      case 'addressLine3':
      setAddressLine3ValidationError('');
      break;
      case 'postCode':
      setPinCodeValidationError('');
      break;
    }

  }

  function resetFindUser() {
    setFindUser({
          
      id: '',
      title: '',
      phoneNo: '',
      country: '',
      state: '',
      district: '',
      taluka: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      postCode: '',
      districtId: '',
      talukId: '',
      brandId: '',
      contactId:'',
      panNo:'',
      panImage: '',
      aadharNo: '',
      aadharImageFront: '',
      aadharImageBack: '',
      voterId: '',
      voterImageFront: '',
      voterImageBack: '',
      dlNo: '',
      dlImageFront: '',
      dlImageBack: '',
      profilePic: ''
    })
  }

  function reassign(selectedTso) {
    const token = localStorage.getItem('access_token');
    if (findUser.id) {
      setLoading(true);
      setLoadingReassignBtn(true);
          const payload = {
            userContactId: findUser.id,
            TSO_contacts_Id: selectedTso.id,
          };
          
          RegistrationService.assignTsoToUser(payload, token)
            .then(res => {
              if (res.success) {
                setLoading(false);
                setFindUserBlock(false)
                resetFindUser()
                setSelectedPersona({id: "", title: ""});
                // setOpenTsoModal(false);
                toast.success(res.response.message)
              } else {
                setLoadingReassignBtn(true);
              }
            })
            .catch(err => {
              // setLoading(false);
              // setLoadingBtn({btn1: false, btn2: false, btn3: false});
            }).finally(() => {
              setLoadingReassignBtn(false);
            });
 
    }
  }

  const handleApproveOrReject = async (key) =>{
    let status = 'true'; //approve
    if(key == '2'){
      status = 'false'; //reject
    }
    let payload = null;
    if (status === 'false') {
      setIsRejectBtnLoading(true)
      payload = {
        userContactId:  findUser.contactId,
        is_approved: key
      }
    } else {
      const validations = [
        { value: findUser.addressLine1, setter: setAddressLine1ValidationError, message: 'Address Line1 is required.' },
        { value: findUser.addressLine2, setter: setAddressLine2ValidationError, message: 'Address Line2 is required.' },
        { value: findUser.addressLine3, setter: setAddressLine3ValidationError, message: 'Address Line3 is required.' },
        { value: findUser.postCode, setter: setPinCodeValidationError, message: 'Pincode is required.' },
        { value: dealerSelected.id, setter: setDealerCodeValidationError, message: 'Dealer is required.' },
      ]
      let isValid = true;
      validations.forEach(({ value, setter, message }) => {
        if (!value) {
         setter(message);
          isValid = false;
        }
        else { 
          setter(''); 
        }
      });

      // if(findUser.postCode.length != 6) {
      //   return toast.error("Enter a valid pincode");
      // }

      if (isValid) {
        if(!new RegExp(/^[1-9][0-9]{5}$/).test(findUser.postCode)) {
          toast.error("Enter a valid pincode");
          return;
       }
        setIsSuccessBtnLoading(true)
        payload = {
            userContactId: findUser.contactId,
            is_approved: key, // key 1 means approve key 2 means reject
            fullName: findUser.title,
            addLine1: findUser.addressLine1,
            addLine2: findUser.addressLine2,
            addLine3: findUser.addressLine3,
            pincode: findUser.postCode,
            dealer_contact_arr: dealerSelected.id ? [dealerSelected.id] : [],
        }
      }
    }
    
    if (payload) {
      try{
        const acceptRejectSubmit = await RegistrationService.userApprovalByTSO(payload)
        

        if(key == 1)
          setIsSuccessBtnLoading(false)
        if(key == 2)
          setIsRejectBtnLoading(false)

        if(acceptRejectSubmit.success == true)
        {
          setShowAlertApprove(true)
          setFindUserBlock(false)
          setDealerSelected({id: "", title: ""})
          toast.success(key == '1'
          ? acceptRejectSubmit.response.message
          : "User rejected")
          resetFindUser()
          setSelectedPersona({
            id:'',
            title:''
          });
        } else{

          if(key == 1)
            setIsSuccessBtnLoading(false)
          if(key == 2)
            setIsRejectBtnLoading(false)

          toast.error(acceptRejectSubmit.response.message)
        }
      }
      catch(e){
        toast.error("Something went wrong")
        if(key == 1)
        setIsSuccessBtnLoading(false)
        if(key == 2)
          setIsRejectBtnLoading(false)
      }
    }
  }

  useEffect(() => {
    reassign(selectedTSE)
  }, [selectedTSE])

  function showTSEModal() {
    setIsTseModalVisible(true)
  }
  return (

    <>
      {/* {loading && <Loader />} */}
      <BreadCrumbSecttion pageTitle="Member Approval" currentPageName="Member Approval" />
      <section className='padTop50'>
        <Container>
          <Row>
            <Col xs={12}>
              <div className='searchBoxBlock my-4'>
                <Row>
                        <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Member Type"
                        requiredStar="*"
                        options={persona}
                        // options={contractorOnly}
                        onChange={handlePersonaChange}
                        selectedValue={selectedPersona}
                        setSelectedValue={setSelectedPersona}
                        page='searchFilter'
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Find User"
                        requiredStar="*"
                        options={findUserOption}
                        onChange={handleFindUserChange}
                        selectedValue={findUser}
                        setSelectedValue={setFindUser}
                        page='searchFilter'
                      />

                    </Col>
                    {selectTSEOption &&
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Select TSE"
                          requiredStar="*"
                          options={selectedTSEList}
                          onChange={handleTSEChoose}
                          selectedValue={selectedTSE}
                          setSelectedValue={setSelectedTSE}
                        />

                      </Col>}
                </Row>
              </div>
            </Col>
          </Row>
          {<Row className='justify-content-center align-item-center h-100'>
            {/* findUserBlock */}
            <Col xs={12}>
              <div className='userInfoBox'>
                <div className="dashboard-details influncerFrm">
                    <Row>
                      <Col xs={12} lg={6}>

                        <InputField inputFieldLabel="Name"
                          editable={false}
                          value={findUser?.title} />

                      </Col>
                      <Col xs={12} lg={6}>

                        <InputField inputFieldLabel="Phone Number"
                          editable={false}
                          value={findUser?.phoneNo} />
                      </Col>

                      <Col xs={12} lg={6}>
                        <InputField
                          inputFieldLabel="Country"
                          editable={false}
                          value={findUser?.country}
                        />
                      </Col>
                      <Col xs={12} lg={6}>
                        <InputField
                          inputFieldLabel="State"
                          editable={false}
                          value={findUser?.state}
                        />
                      </Col>
                      <Col xs={12} lg={6}>
                        <InputField
                          inputFieldLabel="District"
                          editable={false}
                          value={findUser?.district}
                        />
                      </Col>
                      <Col xs={12} lg={6}>
                        <InputField
                          inputFieldLabel="Taluka"
                          editable={false}
                          value={findUser?.taluka}
                        />
                      </Col>
                      <Col xs={12} lg={6}>
                        <InputField
                          inputFieldLabel="Address Line1"
                          value={findUser?.addressLine1}
                          onChange={handleInfluAddressChange}
                          requiredStar="*"
                          name="addressLine1"
                        />
                        {addressLine1ValidationError && (
                                                <div className="error-message">{addressLine1ValidationError}</div>
                                            )}
                      </Col>
                      <Col xs={12} lg={6}>
                        <InputField
                          inputFieldLabel="Address Line2"
                          value={findUser?.addressLine2}
                          name="addressLine2"
                          requiredStar="*"
                          onChange={handleInfluAddressChange}
                        />
                         {addressLine2ValidationError && (
                                                <div className="error-message">{addressLine2ValidationError}</div>
                                            )}
                      </Col>
                      <Col xs={12} lg={6}>
                        <InputField
                          inputFieldLabel="Address Line3"
                          value={findUser?.addressLine3}
                          name="addressLine3"
                          requiredStar="*"
                          onChange={handleInfluAddressChange}
                        />
                         {addressLine3ValidationError && (
                                                <div className="error-message">{addressLine3ValidationError}</div>
                                            )}
                      </Col>
                      <Col xs={12} lg={6}>
                        <InputField
                          inputFieldLabel="Pincode"
                          value={findUser?.postCode}
                          requiredStar="*"
                          name="postCode"
                          onChange={handleInfluAddressChange}
                        />
                         {pinCodeValidationError && (
                                                <div className="error-message">{pinCodeValidationError}</div>
                                            )}
                      </Col>
                      <Col xs={12} lg={6}>
                        <SelectDropDown
                          labelName="Choose Dealer/ARS/Retailer"
                          requiredStar="*"
                          options={dealerOption}
                          onChange={handleDealerChange}
                          selectedValue={dealerSelected}
                          setSelectedValue={setDealerSelected}
                          page='searchFilter' 
                         />
                           {dealerSelected && (
                                                <div className="error-message">{dealerValidationError}</div>
                                            )}
                      </Col>
                      <Col xs={12} lg={3} className=''>
                        <p className='lh-1 mt-1'>Profile picture</p>
                        <DocumentImage imageUrl={findUser.profilePic} title='Profile Image'  />
                      </Col>
                     {/* <Col xs={12} lg={3} className='infApprovalBtnWrap'>
                     
                        <Button variant="secondary" onClick={()=>handleApproveOrReject('2')} disabled={isButtonLoadingReject}>{isButtonLoadingReject ? "Processing..." : "Reject"}</Button>
                        <Button variant="success" onClick={()=>handleApproveOrReject('1')} disabled={isButtonLoading}>{isButtonLoading ? "Processing..." : "Approve"}</Button>
                      </Col> */}
                    </Row>
                </div>
              </div>
            </Col>
          </Row>
                  }
           {findUser.panNo && <Row className='userInfoBox mt-5'>
              <Col xs={12} lg={6}>
                  <InputField inputFieldLabel={"PAN"} value={findUser.panNo} editable={false} />
              </Col>
              <Col xs={12} lg={3}>
                <p className='lh-1 mt-1'>PAN</p>
                <DocumentImage imageUrl={findUser.panImage} title='PAN'  />
              </Col>
            
            </Row>}
           {findUser.aadharNo && <Row className='userInfoBox mt-5'>
              <Col xs={12} lg={6}>
                  <InputField inputFieldLabel={"Aadhar"} value={findUser.aadharNo} editable={false} />
              </Col>
              <Col xs={12} lg={3}>
                <p className='lh-1 mt-1'>Aadhar Front</p>
                <DocumentImage imageUrl={findUser.aadharImageFront} title='Aadhar Front'  />
                {/* <a target='_blank' href={findUser.aadharImageFront}><img id="myimage" src={findUser.aadharImageFront} width="300" height="240" alt="Girl"/></a> */}
              </Col>
              <Col xs={12} lg={3}>
              <p className='lh-1 mt-1'>Aadhar Back</p>
                {/* <a  target='_blank' href={findUser.aadharImageBack}><img id="myimage" src={findUser.aadharImageBack} width="300" height="240" alt="Girl"/></a> */}
                <DocumentImage imageUrl={findUser.aadharImageBack} title='Aadhar Back'  />
              </Col>
            
            </Row>}
           {findUser.voterId && <Row  className='userInfoBox mt-5'>
              <Col xs={12} lg={6}>
                  <InputField inputFieldLabel={"Voter ID"} value={findUser.voterId} editable={false} />
              </Col>
              <Col xs={12} lg={3}>
              <p className='lh-1 mt-1'>Voter ID Front</p>
              <DocumentImage imageUrl={findUser.voterImageFront} title='Voter ID Front'  />
              </Col>
              <Col xs={12} lg={3}>
              <p className='lh-1 mt-1'>Voter ID Back</p>
              <DocumentImage imageUrl={findUser.voterImageBack} title='Voter ID Back'  />
              </Col>
            
            </Row>}
           {findUser.dlNo && <Row className='userInfoBox mt-5'>
              <Col xs={12} lg={6}>
                  <InputField inputFieldLabel={"Driving Licence No."} value={findUser.dlNo} editable={false} />
              </Col>
              <Col xs={12} lg={3}>
              <p className='lh-1 mt-1'>Driving License Front</p>
              <DocumentImage imageUrl={findUser.dlImageFront} title='Driving License Front'  />
              </Col>
              <Col xs={12} lg={3}>
              <p className='lh-1 mt-1'>Driving License Back</p>
              <DocumentImage imageUrl={findUser.dlImageBack} title='Driving License Back'  />
              </Col>
            
            </Row>}
        </Container>
        {findUser.id && <Row className={`buttonWrapBottom transition-2 sticky-bottom mt-5`}>
             <Col xs={12} md ={6} lg={6}> 
              <ColoredButton className={"red-btn"} buttonText={isRejectBtnLoading ? "Processing..." : "Reject"} onClick={()=>handleApproveOrReject('2')} disabled={isRejectBtnLoading}/>
            </Col>
            {/* <Col xs={12} md ={6} lg={4}>
              <ColoredButton className={"yellow-btn"} buttonText={isButtonLoading ? "Processing..." : "Re-assign"} onClick={showTSEModal} disabled={isButtonLoading}/>
            </Col> */}
            <Col xs={12} md ={6} lg={6}>
              <ColoredButton className={"green-btn"} buttonText={isSuccessBtnLoading ? "Processing..." : "Approve"} onClick={()=>handleApproveOrReject('1')} disabled={isSuccessBtnLoading}/>
            </Col>
          </Row>}
      </section>
      <GridModal hasImage={false} title={"TSE/TE"} show={isTseModalVisible} onHide={() => setIsTseModalVisible(false)} data={allTsos} selected={selectedTSE} setSelected={setSelectedTSE}   />
    </>
  )
}

export default InfluencerApproval